import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../middlewares/auth/auth-context'

/**
 * Gate for /admin/* (and legacy admin URL redirects).
 * Non-admins are sent home — do NOT call ErrorContext.setError during render:
 * a brief !isAdmin (auth remount / lazy Suspense) used to stick a 404 while
 * inAdminShell hid the public navbar, which looked like a blank page.
 */
export default function AdminRoute() {
    const authContext = useAuth()
    const location = useLocation()

    if (!authContext.isAdmin) {
        return <Navigate to="/" replace state={{ from: location }} />
    }

    return <Outlet />
}
